<template>
  <sys-data-table
    :height="alturaDaJanela - 157"
    :item-height="45"
    :headers="CABECALHOS_COMPUTED"
    :items="produtos"
    item-key="index"
    @scroll-items="verificarFimScroll"
    @ordernar-coluna-selecionada="ordenarColuna"
  >
    <template #top>
      <div class="d-flex align-center py-3 w-full">
        <v-icon size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium text-systock-blue">Produtos</span>

        <v-divider vertical class="mx-3" />

        <SysBtn class="ml-3" @click="exportarParaExcel">
          <v-icon left>$Excel</v-icon>
          exportar
        </SysBtn>

        <v-spacer />

        <div class="w-450">
          <v-text-field
            v-model="pesquisa"
            hide-details
            dense clearable
            label="Pesquisar"
            append-icon="mdi-magnify"
            v-lazy-input:debounce="2000"
            @input="pesquisarProduto"
          />
        </div>
      </div>
    </template>

    <template #item.descricao_produto="{item}">
      <div class="d-flex align-center text-left">
        <DetalhesProduto :produto="{id_grupo: item.idgrupo, id_filial: 9999, id_produto: item.idproduto, produto_eh_combinacao: item.produto_combinado}" />
        {{ item.descricao_produto }}
      </div>
    </template>

    <template #item.estoque_em_preco_custo_data_inicial="{value}">{{ formatarValorMonetario(value) }}</template>
    <template #item.estoque_em_preco_custo_data_final="{value}">{{ formatarValorMonetario(value) }}</template>
    <template #item.estoque_ideal_em_preco_custo_data_final="{value}">{{ formatarValorMonetario(value) }}</template>
    <template #item.diferenca_em_preco_custo="{value}">{{ formatarValorMonetario(value) }}</template>
    <template #item.crescimento_em_preco_custo="{value}">{{ formatarValorMonetario(value) }}</template>
  </sys-data-table>
</template>

<script>
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import {cabecalhos} from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/DetalhamentoDuploClique/Cabecalhos"
import {buscarProdutosDetalhamento} from "@/api/Diagnostico/SlowNoMoving/MovimentacaoEstoque";
import {formatarParametrosObjParaUrl, formatarValorMonetario, logout} from "@/helpers";
import $axios from "@/api/api";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

export default {
  name: "Tabela",
  components: {
    DetalhesProduto
  },
  mixins: [ResponsiveHeight],
  props: {
    linha: Object,
    filtros: Object,
    periodo_analise: Object,
  },
  data: () => ({
    produtos: [],
    pesquisa: '',
    timer_scroll_data_table: null,
    todos_itens_paginados_carregados: false,
    produtos_por_pagina: 200,
    order_by: []
  }),
  computed: {
    CABECALHOS_COMPUTED() {
      const callback = item => ({
        ...item,
        text: item.text.replaceAll("{data_inicial}", this.periodo_analise.data_inicial)
          .replaceAll("{data_final}", this.periodo_analise.data_final)
      });

      return cabecalhos.map(callback);
    },
    PAGINA_ATUAL_PRODUTOS() {
      return Math.ceil(this.produtos.length / this.produtos_por_pagina);
    },
    FILTROS_STORE() {
      return this.$store.getters['filtrosUniversalAvancado/filtros_formatados'];
    },
    PARAMETROS_PRODUTOS() {
      return {
        ...this.FILTROS_STORE,
        id_status_movimentacao: this.linha.id_status_movimentacao || 0,
        status_produto: this.filtros.status_produto,
        compradores: this.filtros.compradores,
        segmentos: this.linha.idsegmento ? [this.linha.idsegmento] : this.filtros.segmentos,
        produto_combinado: (this.linha.idsegmento !== undefined && this.linha.descricao_linha === 'COMBINADOS') ? 'S' : 'N',
        fornecedores: this.linha.idfornecedor ? [this.linha.idfornecedor] : this.filtros.fornecedores,
        produtos: this.linha.idproduto ? [this.linha.idproduto] : [],
        data_inicial: this.periodo_analise.data_inicial,
        data_final: this.periodo_analise.data_final,
        pesquisa: this.pesquisa,
      }
    }
  },
  created() {
    this.buscarProdutosDetalhamento();
  },
  methods: {
    ordenarColuna(ev) {
      if (ev.value === this.order_by[0] && ev.order === this.order_by[1]) return;

      this.produtos = [];
      this.todos_itens_paginados_carregados = false;

      this.order_by = [ev.value, ev.order];
      this.buscarProdutosDetalhamento();
    },
    formatarValorMonetario,
    buscarProdutosDetalhamento() {
      if (this.todos_itens_paginados_carregados) {
        return;
      }

      const parametros = {
        ...this.PARAMETROS_PRODUTOS,
        pagina: (this.PAGINA_ATUAL_PRODUTOS + 1),
        produtos_por_pagina: this.produtos_por_pagina,
        order_by: this.order_by
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarProdutosDetalhamento(parametros)
          .then(produtos => {
            this.produtos.push(...this.gerarIndexProdutosGrupo(produtos));

            if (produtos.length < this.produtos_por_pagina) {
              this.todos_itens_paginados_carregados = true;
            }
          })
          .catch(logout)
      );
    },
    gerarIndexProdutosGrupo(itens) {
      const callback = item => ({ ...item, index: `${item.idgrupo}-${item.idproduto}` });
      return itens.map(callback);
    },
    pesquisarProduto() {
      this.produtos = [];
      this.todos_itens_paginados_carregados = false;
      this.buscarProdutosDetalhamento();
    },
    verificarFimScroll({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 100) < scrollHeight || !(this.produtos.length > 0)) return;
      clearTimeout(this.timer_scroll_data_table);
      this.timer_scroll_data_table = setTimeout(() => this.buscarProdutosDetalhamento(), 500);
    },
    exportarParaExcel() {
      const parametros = formatarParametrosObjParaUrl(this.PARAMETROS_PRODUTOS);
      const url = `${$axios.defaults.baseURL}/relatorios/diagnostico/slow-no-moving/indicador-movimentacao-estoque/produtos${parametros}`
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>

</style>
